@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.occasions {
    grid-column: 1 / span 2;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-column: 1 / span 1;
    }
}

.heading {
    text-transform: uppercase;
}

.occasionFields {
    margin: 1em 0;
    display: flex;
    gap: 1em;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        gap: 0.75rem;
    }
}

.occasionField {
    & label {
        & > div:first-of-type {
            // Visually hide the text label
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            margin: -1px;
            overflow: hidden;
            clip-path: inset(50%);
            border: 0;
        }
    }
}

.removeOccasion {
    composes: textButton from "../../styles/buttons.module.scss";

    &::before {
        content: "- ";
    }
}

.addOccasion {
    composes: button from "../../styles/buttons.module.scss";

    &::before {
        content: "+ ";
    }
}
